export default
[
    {
        title:"People",
        artist:"Libianca, Becky G",
        img:require("../../assets/img/songs/people.jpeg"),
        source:require("../../assets/audios/People.mp3")
    },
    {
        title:"Lover",
        artist:"Taylor Swift",
        img:require("../../assets/img/songs/lover.jpg"),
        source:require("../../assets/audios/Lover.mp3")
    },
    {
        title:"Flowers",
        artist:"Miley Cyrus",
        img:require("../../assets/img/songs/flowers.jpeg"),
        source:require("../../assets/audios/Flowers.mp3")
    },
    {
        title:"Odiyamma",
        artist:"Hesham Abdul Wahab,Dhruv Vikram,Shruti Haasan,Chinmayi Sripaada",
        img:require("../../assets/img/songs/Odiyamma-Song.jpeg"),
        source:require("../../assets/audios/Odiyamma.mp3"),
    },
    {
        title:"Dandelions",
        artist:"Ruth B.",
        img:require("../../assets/img/songs/dandelions.jpeg"),
        source:require("../../assets/audios/Dandelions.mp3"),
    }
]